import React from 'react';

import { correctingTrailingNumbers, bemCssModules } from '@cryptoboyio/mercuryo-lab/utils';
import { useSelector } from 'react-redux';

import { useNavigate } from '@utils/hooks';

import { useStore } from '@modules';
import { WalletLimitsType } from '@modules/wallet/types';

import useConverterState from '@containers/Converter/useConverterState';
import { isEEACompliant } from '@selectors';

import style from './Limits.scss';

const cn = bemCssModules(style, 'Limits');

export type TLimits = {
  limits?: WalletLimitsType;
} & ReturnType<typeof useConverterState>;

const Limits: CustomFC<TLimits> = props => {
  const {
    className,
    limits,
    focusedCurrency,
    fromAmount,
    fromCurrency,
    toCurrency,
    showLimits,
    setFromLimit,
    setToLimit,
  } = props;

  const [{ global }] = useStore();
  const navigate = useNavigate();
  const isEEA = useSelector(isEEACompliant);
  const { display_options } = global.currencies.config;

  const currency = focusedCurrency || fromCurrency || toCurrency;

  const totalDigits = display_options?.[currency]?.total_digits;
  const displayDigits = display_options?.[currency]?.display_digits;
  const isHiddenLimits = isEEA && !(Number(fromAmount) > 0);
  const min = correctingTrailingNumbers(limits?.[currency]?.min || '', displayDigits, totalDigits);
  const max = correctingTrailingNumbers(limits?.[currency]?.max || '', displayDigits, totalDigits);

  const handleClick = (value: string) => {
    if (toCurrency === focusedCurrency) {
      setToLimit(value);
      setFromLimit('');
    } else {
      setFromLimit(value);
      setToLimit('');
    }
  };
  const handleClickAll = () => navigate(CONST.nav.limits);

  if (isHiddenLimits || (!min && !max)) return null;

  return (
    <div className={cn({ hidden: !showLimits }, [className])}>
      {min && (
        <button
          className={cn('button', ['small', 'link'])}
          type="button"
          onClick={() => handleClick(min)}
        >
          Min&nbsp;{min}
        </button>
      )}
      {max && (
        <button
          className={cn('button', ['small', 'link'])}
          type="button"
          onClick={() => handleClick(max)}
        >
          Max&nbsp;{max}
        </button>
      )}
      <button className={cn('button', ['small', 'link'])} type="button" onClick={handleClickAll}>
        All limits
      </button>
    </div>
  );
};

export default Limits;
